import type { AppCopy } from '../catalogs';

export const ltAppCopy = {
  welcomeHeading: 'Kaip aš galiu tau padėti šiandien?',
  thinking: 'Mąstymas',
  scrollToBottom: 'Slinkite į apačią',
  reasoning: 'Samprotavimas',
  reasoningInProgress: 'vyksta',
  citationPages: 'Puslapiai {first}–{last}',
  citationTitle: 'Šaltinio ištrauka',
  citationLoading: 'Įkeliamas šaltinis…',
  citationUnavailable: 'Cituojamas tekstas nepasiekiamas arba nebeturite prieigos.',
  citationOpen: 'Atverti šaltinį',
  citationCopied: 'Citata nukopijuota',
  copy: 'Kopijuoti',
  more: 'Daugiau',
  tryAgain: 'Bandykite dar kartą',
  answerTruncated: 'Atsakymas pasiekė ilgio ribą ir buvo nutrauktas.',
  continueAnswer: 'Tęsti atsakymą',
  exportMarkdown: 'Eksportuoti kaip Markdown',
  edit: 'Redaguoti',
  cancel: 'Atšaukti',
  update: 'Atnaujinti',
  previous: 'Ankstesnis',
  next: 'Kitas',
  messagePlaceholder: 'Siųsti žinutę…',
  projectHomePlaceholder: 'Naujas pokalbis: {project}',
  sharedChatEveryone: 'Visi įmonėje {company} gali skaityti šį pokalbį',
  sharedChatOnePerson: '1 asmuo gali skaityti šį pokalbį',
  sharedChatPeople: 'Šį pokalbį gali skaityti asmenų: {count}',
  forkedChatPlaceholder: 'Tęskite su savo ryšiais…',
  newAnswer: 'Naujas atsakymas',
  messageInput: 'Pranešimo įvedimas',
  sendMessage: 'Siųsti žinutę',
  stopGenerating: 'Nustokite generuoti',
  addAttachment: 'Pridėti priedą',
  removeFile: 'Pašalinti failą',
  attachmentPreview: 'Priedo peržiūra',
  imageAttachmentPreview: 'Vaizdo priedo peržiūra',
  image: 'Vaizdas',
  openLink: 'atidaryti nuorodą',
  document: 'dokumentas',
  file: 'Failas',
  attachment: 'priedą',
  uploadFailed: 'įkelti nepavyko',
  uploading: 'įkėlimas',
  toolIncomplete: 'Nebaigta',
  toolActivity: 'Veikla',
  activityThinking: 'Mąsto…',
  activityWriting: 'Rašo…',
  activityWaiting: 'Laukiama jūsų patvirtinimo',
  activityStopped: 'Sustabdyta',
  activityCouldNotFinish: 'Nepavyko užbaigti',
  activitySources: 'šaltiniai',
  activityShowThinking: 'Rodyti mąstymą',
  activityOpen: 'Atverti veiklą',
  activitySteps: 'Žingsniai',
  activitySourcesTab: 'Šaltiniai',
  activityUnavailable: 'Ši veikla nepasiekiama.',
  activityInput: 'Įvestis',
  activityOutput: 'Išvestis',
  activityNoSources: 'Atsakyme šaltiniai necituoti.',
  activityApprovedByReply: 'Patvirtinta jūsų atsakymu',

  toolRunning: 'Vykdoma',
  toolComplete: 'Baigta',
  toolNeedsApproval: 'Reikia patvirtinimo',
  toolInput: 'Įvestis',
  toolCall: 'įrankio skambutis',
  toolCalls: 'įrankių skambučiai',
  openMenu: 'Atidaryti meniu',
  closeMenu: 'Uždaryti meniu',
  close: 'Uždaryti',
  showInTextField: 'Rodyti teksto lauke',
  settings: 'Nustatymai',
  appearance: 'Išvaizda',
  themeLight: 'Šviesi',
  themeDark: 'Tamsi',
  themeSystem: 'Sistema',
  themeChoiceHelp:
    'Taikoma visuose jūsų įrenginiuose. „Sistema“ atitinka kiekvieno įrenginio šviesųjį arba tamsųjį režimą.',
  themeSaveFailed: 'Nepavyko išsaugoti išvaizdos, todėl ji nepakeista. Bandykite dar kartą.',
  toolUsed: 'Naudotas įrankis',
  toolCancelled: 'Atšauktas įrankis',
  toolResult: 'Rezultatas:',
  toolError: 'Klaida:',
  toolCancelledReason: 'Atšaukta priežastis:',
  approvalAllow: 'Leisti',
  approvalAlwaysAllow: 'Visada leisti',
  approvalDeny: 'Atmesti',
  approvalAlwaysDeny: 'Visada atmesti',
  approvalConfirm: 'Patvirtinti',
  approvalBack: 'Atgal',
  approvalApprovedResult: 'Patvirtino vartotojo',
  approvalDeniedResult: 'Vartotojas atmetė įrankio vykdymą',
  logout: 'Atsijungti',
  loginOrCreateAccount: 'Prisijungti / Susikurti paskyrą',
  newChat: 'Naujas pokalbis',
  untitledChat: 'Pokalbis be pavadinimo',
  previousChats: 'Ankstesni pokalbiai',
  openChat: 'Atidaryti pokalbį {title}',
  moreActionsForChat: 'Daugiau veiksmų, skirtų {title}',
  chatActions: 'Pokalbių veiksmai',
  closeChatActions: 'Uždaryti pokalbio veiksmus',
  deleteChatQuestion: 'Ištrinti pokalbį?',
  deleteChatDescription: 'Pokalbis „{title}“ bus ištrintas visam laikui.',
  deleteChat: 'Ištrinti pokalbį',
  keepChat: 'Išsaugoti pokalbį',
  delete: 'Ištrinti',
  deleting: 'Ištrinama…',
  chatDeleteFailed: 'Pokalbio nepavyko ištrinti. Bandykite dar kartą.',
  settingsDescription: 'Tinkinkite, kaip asistentas dirba jums.',
  settingsDesktopDescription: 'Tinkinkite, kaip asistentas reaguos į jus.',
  personalization: 'Personalizavimas',
  personalizationDescription:
    'Tinkinkite instrukcijas, kurių asistentas vadovaujasi kiekviename atsakyme.',
  languageAndRegion: 'Kalba ir regionas',
  languageAndRegionDescription: 'Pasirinkite kalbą ir laiko juostą.',
  memories: 'Prisiminimai',
  memoriesDescription:
    'Peržiūrėkite, redaguokite arba ištrinkite, ką asistentas prisimena apie jus.',
  account: 'sąskaita',
  accountDescription: 'Tvarkykite paskyrą ir visam laikui ištrinkite savo duomenis.',
  backToSettings: 'Grįžti į nustatymus',
  closeSettings: 'Uždaryti nustatymus',
  settingsCategories: 'Nustatymų kategorijos',
  yourSettings: 'Jūsų nustatymai',
  dataAndAccount: 'Duomenys ir sąskaita',
  viewAndManageMemories: 'Peržiūrėkite ir valdykite, ką asistentas prisimena',
  loginToUseMemories: 'Prisijunkite, kad galėtumėte naudoti prisiminimus',
  manageOrDeleteAccount: 'Tvarkyti arba ištrinti paskyrą',
  unsavedChanges: 'Turite neišsaugotų pakeitimų',
  unsavedCloseDescription: 'Uždarius nustatymus, šiame puslapyje atlikti pakeitimai bus atmesti.',
  unsavedBackDescription: 'Grįžus atgal bus atmesti šio puslapio pakeitimai.',
  continueEditing: 'Tęsti redagavimą',
  discardChanges: 'Atmesti pakeitimus',
  saveChanges: 'Išsaugoti pakeitimus',
  localSettingsNote: 'Išsaugota šioje naršyklėje. Prisijunkite, kad išsaugotumėte savo paskyroje.',
  personality: 'Asmenybė',
  personalityHelp:
    'Individualizuotos instrukcijos, kurių asistentas vadovaujasi kiekviename atsakyme',
  personalityPlaceholder:
    'Pavyzdžiui: būk glausta ir konkreti. Aš gyvenu Geteborge ir mėgstu vegetarišką maistą.',
  timezone: 'Laiko juosta',
  searchTimezone: 'Ieškoti laiko juostų…',
  automaticBrowser: 'Automatinis (naršyklė)',
  saved: 'Išsaugotas {date}',
  addMemory: 'Pridėti prisiminimą',
  newMemory: 'Naujas prisiminimas',
  memoryPlaceholder: 'Pavyzdžiui: mėgstu trumpus ir konkrečius atsakymus.',
  editMemory: 'Redaguoti prisiminimą',
  saveMemory: 'Išsaugoti prisiminimą',
  deleteMemory: 'Ištrinti prisiminimą',
  memorySaveFailed: 'Nepavyko išsaugoti atminties. Bandykite dar kartą.',
  memoryLimitReached: 'Galite išsaugoti iki 50 prisiminimų. Ištrinkite vieną prieš pridėdami kitą.',
  memoryInvalid: 'Prisiminimuose negali būti nuorodų. Pašalinkite nuorodą ir bandykite dar kartą.',
  memoryDeleteFailed: 'Nepavyko ištrinti atminties. Bandykite dar kartą.',
  memoryLoadFailed: 'Nepavyko įkelti prisiminimų.',
  loadingMemories: 'Įkeliami prisiminimai…',
  emptyMemories:
    'Asistentas išsaugo prisiminimus apie jus, kol kalbate – ką mėgstate, kur gyvenate ir ką veikiate. Čia galite juos peržiūrėti, redaguoti ir ištrinti.',
  deleteAccountHelp:
    'Visam laikui ištrinkite paskyrą ir visus susijusius pokalbius, prisiminimus ir nustatymus.',
  deleteAccount: 'Ištrinti paskyrą',
  deleteAccountQuestion: 'Visam laikui ištrinti paskyrą?',
  deleteAccountDescription:
    'Visi pokalbiai, pranešimai, prisiminimai, nustatymai ir prisijungimo kredencialai bus ištrinti. Šio veiksmo anuliuoti negalima.',
  deleteAccountConfirm: 'Taip, ištrinti mano paskyrą',
  accountDeleteFailed: 'Paskyros nepavyko ištrinti. Niekas nepašalinta – bandykite dar kartą.',
  logoutEverywhereTitle: 'Visi įrenginiai',
  logoutEverywhereHelp:
    'Atsijunkite visuose įrenginiuose ir naršyklėse, kuriose atidaryta jūsų paskyra, įskaitant šį.',
  logoutEverywhere: 'Atsijungti visur',
  logoutEverywhereQuestion: 'Atsijungti visuose įrenginiuose?',
  logoutEverywhereDescription:
    'Turėsite vėl prisijungti visuose įrenginiuose ir naršyklėse, įskaitant šį. Jūsų pokalbiai ir nustatymai liks tokie patys.',
  loggingOut: 'Atsijungiama…',
  logoutEverywhereFailed:
    'Nepavyko patvirtinti, kad atsijungėte visur. Bandykite dar kartą arba kitame įrenginyje patikrinkite, ar vis dar esate prisijungę.',
  settingsSaveFailed: 'Nepavyko išsaugoti nustatymų. Bandykite dar kartą.',
  customInstructions: 'Individualios instrukcijos',
  notSet: 'Nenustatyta',
  automaticLanguage: 'Automatinė kalba',
  automaticTimezone: 'automatinė laiko juosta',
  appLanguage: 'Programos kalba',
  appLanguageHelp:
    'Valdo visą programos sąsają ir datas. Padėjėjo atsakymai ir toliau pateikiami ta kalba, kuria rašote.',
  automaticBrowserLanguage: 'Automatinis (naršyklės kalba)',
  previousLanguageChoice: 'Ankstesnis pasirinkimas: {language} ({locale})',
  previousLanguageChoiceCode: 'Ankstesnis pasirinkimas ({locale})',
  canvasCopyLink: 'Kopijuoti nuorodą',
  canvasLinkCopied: 'Nuoroda nukopijuota',
  actionUpdatedWithEdits: 'Atnaujinta pagal jūsų pakeitimus',
  activityStepsDone:
    'one:veiksmas atliktas|few:veiksmai atlikti|many:veiksmo atlikta|other:veiksmų atlikta',
  activityResultsCount: 'one:rezultatas|few:rezultatai|many:rezultato|other:rezultatų',
  canvasCopyLinkFailed: 'Nepavyko nukopijuoti nuorodos',
  canvasOpenInAgent: 'Atidaryti programoje {agent}',
  canvasExpand: 'Išskleisti',
  canvasExitFullView: 'Išeiti iš viso rodinio',
  webSourceUnread:
    'Nuoroda šiame atsakyme. Poneva neskaitė šio puslapio, todėl čia nėra ką rodyti.',
  webSourceOpenOriginal: 'Atidaryti originalą',
  toolProgressSettings: 'Keičiami jūsų nustatymai…',
  toolProgressAgent: 'Kuriamas agentas…',
  toolProgressConnections: 'Ieškoma ryšio parinkčių…',
  toolProgressResult: 'Ruošiamas jūsų rezultatas…',
  toolProgressClarification: 'Ruošiamas patikslinimas…',
  toolProgressKnowledge: 'Ruošiamas siūlomas žinių atnaujinimas…',
  toolProgressQuestion: 'Ruošiamas klausimas jums…',
  toolProgressSkill: 'Formuojamas jūsų Skill…',
  toolErrorSettings: 'Jūsų nustatymai nepakeisti.',
  toolErrorAgent: 'Nepavyko sukurti agento.',
  toolErrorConnections: 'Nepavyko įkelti ryšio parinkčių.',
  toolErrorResult: 'Rezultatas neišsaugotas.',
  toolErrorClarification: 'Nepavyko paruošti patikslinimo.',
  toolErrorKnowledge: 'Nepavyko paruošti siūlomo žinių atnaujinimo.',
  toolErrorQuestion: 'Nepavyko paruošti klausimo.',
  toolErrorSkill: 'Nepavyko išsaugoti Skill juodraščio.',
  toolErrorOpenSettings: 'Atidaryti Nustatymus',
  toolErrorOpenAgents: 'Atidaryti Agentus',
  toolErrorOpenConnections: 'Atidaryti Jungtis',
  toolStepIncomplete: 'Šis veiksmas nebuvo užbaigtas.',
  toolEarlierAttemptsFailed:
    'one:ankstesnis bandymas nepavyko|few:ankstesni bandymai nepavyko|many:ankstesnio bandymo nepavyko|other:ankstesnių bandymų nepavyko',
} satisfies AppCopy;
